import { Contract } from "@edp-components/edp-contract";
import moment from "moment";

export interface IFunciona {
    plafond: FuncionaPlafond;
    validity: FuncionaValidity;
    productId: string;
    tax: string;
}

export interface FuncionaPlafond {
    totalWithoutTax: number;
    availableWithoutTax: number;
    visits: number;
    total: number;
    available: number;
}

export interface FuncionaValidity {
    StartDate: string;
    EndDate: string;
}

interface IFuncionaCalculate {
    plafondTotal: number;
    plafondAvailable: number;
    plafondUsed: number;
}

export function caculatePercentageOfVATAvaliableAndTotalAndCheckAlreadyHasTaxApplied(funciona: IFuncionaCalculate, contract: Contract) {
    const plafondEazyLimitWihtVAT = 100;
    const plafondSmartLimitWihtVAT = 300;
    const plafondFullLimitWihtVAT = 600;

    if (contract.HasPack.easy) {
        if (funciona.plafondTotal < plafondEazyLimitWihtVAT) {
            addPlafondPercentages(funciona);
            return;
        }
    }
    if (contract.HasPack.full_sm || contract.HasPack.full) {
        if (funciona.plafondTotal < plafondFullLimitWihtVAT) {
            addPlafondPercentages(funciona);
            return;
        } else {
            return funciona;
        }
    }

    if (contract.HasPack.smart) {
        if (funciona.plafondTotal < plafondSmartLimitWihtVAT) {
            addPlafondPercentages(funciona);
            return;
        } else {
            return funciona;
        }
    }
}

export function addPlafondPercentages(funciona): void {
    funciona.plafondTotal = percentageCaculate(funciona.plafondTotal);
    funciona.plafondAvailable = percentageCaculate(funciona.plafondAvailable);
}

export function percentageCaculate(funcionaNumber: number) {
    return Math.round(funcionaNumber * (1 + 23 / 100));
}

export function calculateFunciona(funciona: IFunciona, contract: Contract): IFuncionaCalculate {
    const dataChart: IFuncionaCalculate = { plafondTotal: 0, plafondAvailable: 0, plafondUsed: 0 };
    dataChart.plafondTotal = funciona.plafond.total;
    dataChart.plafondAvailable = funciona.plafond.available;
    caculatePercentageOfVATAvaliableAndTotalAndCheckAlreadyHasTaxApplied(dataChart, contract);
    if (contract.HasPack && funciona.plafond.available > 0) {
        if (moment(funciona.validity.StartDate) < moment("2021-08-29")) {
            dataChart.plafondTotal -= 100;
            dataChart.plafondAvailable -= 100;
        }

        if (moment(funciona.validity.StartDate) > moment("2021-08-28") && moment(funciona.validity.StartDate) < moment("2021-12-13")) {
            if (contract.HasPack.easy) {
                dataChart.plafondTotal = funciona.plafond.totalWithoutTax >= 100 ? dataChart.plafondTotal - 100 : dataChart.plafondTotal;
                dataChart.plafondAvailable =
                    funciona.plafond.totalWithoutTax >= 100 ? dataChart.plafondAvailable - 100 : dataChart.plafondAvailable;
            } else if (contract.HasPack.smart) {
                dataChart.plafondTotal = funciona.plafond.totalWithoutTax >= 300 ? dataChart.plafondTotal - 100 : dataChart.plafondTotal;
                dataChart.plafondAvailable =
                    funciona.plafond.totalWithoutTax >= 300 ? dataChart.plafondAvailable - 100 : dataChart.plafondAvailable;
            } else {
                dataChart.plafondTotal = funciona.plafond.totalWithoutTax >= 550 ? dataChart.plafondTotal - 100 : dataChart.plafondTotal;
                dataChart.plafondAvailable =
                    funciona.plafond.totalWithoutTax >= 550 ? dataChart.plafondAvailable - 100 : dataChart.plafondAvailable;
            }
        }
    }

    dataChart.plafondUsed = dataChart.plafondTotal - dataChart.plafondAvailable;
    return dataChart;
}
